import React from 'react';

/**
 * A simple loading component to display while lazy-loaded components are being fetched
 */
const LoadingComponent = ({ message = 'Loading...' }) => {
  return (
    <div className="loading-container">
      <div className="loading-spinner"></div>
      <p>{message}</p>
    </div>
  );
};

export default LoadingComponent; 